import flatMap from "array.prototype.flatmap";
import AggregateError from "es-aggregate-error";
import globalThis from "globalthis";
import fromEntries from "object.fromentries";
import promiseAny from "promise.any";

export function shim() {
  flatMap.shim();
  AggregateError.shim();
  globalThis.shim();
  fromEntries.shim();
  promiseAny.shim();
}
